import React from 'react';
import './OtherUserProfile.css';

function OtherUserProfile() {
  return (
        <>
            <div id="1st_user" class="users">
                <div className="image_name">
                    <div >
                        <img className="image" src='./images/user.png' />
                    </div>
                    <div className="name_username">
                        <div className="name">
                            <p>Cynbaby</p>
                        </div>
                        <div className="username">
                            <p>Cynthia Olukole</p>
                        </div>
                    </div>
                </div>
                <div class="button">
                    <button type="submit"><a href="profile" class="white-text">View profile</a> </button>
                </div>
            </div>
            
            
        </>
    
    
    );
}

export default OtherUserProfile;
